import Dashboard from './menu/dashboard/Dashboard.vue';
import Profile from './menu/profile/Profile.vue';

import MessageService from './menu/message_service/MessageService.vue';
import MessageServiceRoutes from './menu/message_service/router';

import ShortenerService from './menu/shortener_service/ShortenerService.vue';
import ShortenerServiceRoutes from './menu/shortener_service/router';

import Px from './menu/px/Px.vue';
import pxRoutes from './menu/px/router';

import Marketing from './menu/marketing/Marketing.vue';
import marketingRoutes from './menu/marketing/router';

import Cx from './menu/cx/Cx.vue';
import cxRoutes from './menu/cx/router';

import Finance from './menu/finance/Finance.vue';
import FinanceRoutes from './menu/finance/router';

import superAdmin from './menu/superadmin/SuperAdmin.vue';
import superAdminRoutes from './menu/superadmin/router';

import PPOB from './menu/ppob/PPOB.vue';
import PPOBRoutes from './menu/ppob/router';

const appRoutes = [
  {
    path: '/dashboard',
    name: 'dashboard',
    component: Dashboard,
    meta: {
      roles: ['superadmin', 'px', 'ce', 'marketing'],
    },
  },
  {
    path: '/profile',
    name: 'profile',
    component: Profile,
    meta: {
      roles: ['superadmin', 'px', 'ce', 'marketing'],
    },
  },
  {
    path: '/px',
    name: 'px',
    component: Px,
    children: pxRoutes,
    meta: {
      roles: ['superadmin', 'px'],
    },
  },
  {
    path: '/message-service',
    name: 'message-service',
    component: MessageService,
    children: MessageServiceRoutes,
    meta: {
      roles: ['superadmin'],
    },
  },
  {
    path: '/shortener-service',
    name: 'shortener-service',
    component: ShortenerService,
    children: ShortenerServiceRoutes,
    meta: {
      roles: ['superadmin'],
    },
  },
  {
    path: '/marketing',
    name: 'marketing',
    component: Marketing,
    children: marketingRoutes,
    meta: {
      roles: ['superadmin', 'marketing'],
    },
  },
  {
    path: '/cx',
    name: 'cx',
    component: Cx,
    children: cxRoutes,
    meta: {
      roles: ['superadmin', 'ce', 'customer_success', 'operation', 'mentor', 'finance'],
    },
  },
  {
    path: '/finance',
    name: 'finance',
    component: Finance,
    children: FinanceRoutes,
    meta: {
      roles: ['superadmin', 'finance', 'ce', 'refund'],
    },
  },
  {
    path: '/super-admin',
    name: 'superAdmin',
    component: superAdmin,
    children: superAdminRoutes,
    meta: {
      roles: ['superadmin', 'px', 'ce', 'marketing'],
    },
  },
  {
    path: '/ppob',
    name: 'ppob',
    component: PPOB,
    children: PPOBRoutes,
    meta: {
      roles: ['superadmin', 'finance', 'ce', 'refund'],
    },
  },


];

// appRoutes.beforeEach((to, from, next) => {

//   // next();
// })

export default appRoutes;
